<template>
  <div class="business-settings-inline-form">
    <v-form ref="editCashRegisterForm" @submit.prevent="submit">
      <v-card flat>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                autofocus
                dense
                outlined
                label="Naziv"
                v-model="register.name"
                :rules="[rules.req]"
                class="form-input"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                dense
                outlined
                label="Oznaka blagajne"
                v-mask="'###########'"
                hint="Samo brojevi"
                v-model="register.number"
                :rules="[rules.req, rules.reservedIds]"
                class="form-input"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="pt-0">
              <money-input
                v-if="loaded"
                dense
                outlined
                label="Polog na blagajni"
                v-model="register.deposit"
                ref="deposit"
                :currency="currency"
                class="form-input"
              >
              </money-input>
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-select
                dense
                outlined
                label="Vrsta blagajne"
                v-model="register.type"
                :items="registerTypes"
                item-text="name"
                class="form-input"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="pt-0">
              <v-select
                dense
                outlined
                label="Vrsta prijave na blagajnu"
                v-model="register.login_type"
                :items="registerLoginTypes"
                :rules="[rules.req]"
                item-text="name"
                class="form-input"
              >
              </v-select>
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-select
                dense
                outlined
                label="Nakon izdavanja računa"
                v-model="register.after_receipt_behaviour"
                :items="afterReceiptBehaviours"
                :rules="[rules.req]"
                item-text="name"
                item-value="value"
                class="form-input"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="pt-0">
              <v-select
                class="pb-3 form-input"
                outlined
                dense
                label="Odaberite printer"
                :items="printers"
                item-text="name"
                item-value="id"
                return-object
                hide-details
                v-model="register.printer"
                :rules="[rules.req]"
              ></v-select>
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-select
                class="pb-3 form-input"
                outlined
                multiple
                dense
                label="Odaberite terminale"
                :items="terminals"
                item-text="name"
                return-object
                hide-details
                v-model="register.terminals"
              ></v-select>
            </v-col>
          </v-row>
          <!-- <v-row class="">
            <v-col class="pt-2">
              <v-select
                class="pb-3"
                outlined
                dense
                label="Odaberite način naplate"
                :items="terminalTypes"
                item-text="name"
                item-value="id"
                hide-details
                v-model="register.terminal_type"
              ></v-select>
            </v-col>
          </v-row> -->
        </v-card-text>
        <v-card-actions class="d-flex justify-end form-footer-sticky">
          <v-btn
            class="btn-primary"
            :loading="submitting"
            :disabled="submitting"
            type="submit"
          >
            <v-icon left small color="#fff">mdi-content-save</v-icon>
            Spremi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
    <add-printer ref="addPrinter"></add-printer>
  </div>
</template>
<script>

import rules from '@/plugins/rules'
import { df, auth } from '@/plugins/firebase'
import { v4 as uuidv4 } from 'uuid'
import state from '@/state'
import { clone, duck, currencyToFloat } from '@/plugins/utils'
import MoneyInput from '@/components/MoneyInput'
import AddPrinter from '@/modules/point-of-sale/components/printer-configuration/AddPrinter'

export default {
  name: 'AddCashRegister',
  props: {
    cashRegister: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    location: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    submitting: false,
    error: {
      show: false,
      message: undefined
    },
    rules: {
      req: rules.req(),
      eq: rules.eq,
      reservedIds: () => true
    },
    registerName: undefined,
    registerNumber: undefined,
    maxHolding: undefined,
    register: {},
    initialRegister: {},
    registerDefults: {},
    registerTypes: [],
    terminals: [],
    registerLoginTypes: [],
    afterReceiptBehaviour: undefined,
    afterReceiptBehaviours: [],
    printers: [],
    selectedPrinter: undefined,
    listeners: [],
    currency: 'EUR',
    loaded: false
    // terminalTypes: [{
    //   name: 'Prije izdavanja računa',
    //   id: 'before'
    // }, {
    //   name: 'Nakon izdavanja računa',
    //   id: 'after'
    // }]
  }),
  inject: ['showMsgBox', 'showLoader', 'hideLoader', 'confirm', 'confirmClose'],
  components: { MoneyInput, AddPrinter },

  computed: {
    reservedIds () {
      return state.registerIds
    }
  },
  beforeDestroy () {
    if (this.listeners) {
      this.listeners.forEach(listener => listener())
      this.listeners = []
    }
  },
  async mounted () {
    // EntityTree.vue sad čita blagajne direktno iz cash_registers (kanonska
    // kolekcija), pa this.cashRegister već sadrži pun dokument (uklj. deposit) —
    // nema više potrebe za dodatnim fetchom ovdje.
    const register = clone(this.cashRegister)
    var temp = []
    if (register.terminals) {
      Object.keys(register.terminals).forEach(key => {
        temp.push(register.terminals[key])
      })

      register.terminals = temp
    }

    const printers = []
    this.initialRegister = clone(register)
    this.initialRegister.deposit = register.deposit?.amt || 0
    this.register = clone(register)

    printers.push({ name: 'POS printer 58mm (T58)', value: 'T58', id: 'T58', library: 'NONE', width: 'T58' })
    printers.push({ name: 'POS printer 80mm (T80)', value: 'T80', id: 'T80', library: 'NONE', width: 'T80' })
    printers.push({ name: 'Klasični printer (A4)', value: 'A4', id: 'A4', library: 'NONE', width: 'A4' })
    const terminals = []
    const query = df
      .collection(`location_printers/${this.location.id}/printers`)
    const listener = query
      .onSnapshot((doc) => {
        doc.docs.forEach((rec) => {
          printers.push(rec.data())
        })
        this.printers = clone(printers.sort((a, b) => a.name.localeCompare(b.name)))
        state.setInstalledPrinters(this.printers)
      }
      )
    this.listeners.push(listener)

    // this.listeners.push(listener)
    this.submitting = false
    this.registerDefults = Object.assign(this.registerDefults, register)

    // this.register = Object.assign(this.register, register)
    this.register.deposit = register.deposit?.amt || 0

    if (this.register.printer && this.register.printer !== '') {
      this.printers.forEach(printer => {
        if (printer.id === this.register.printer) {
          this.register.printer = printer
        }
      })
    }

    const terminalsListener = df
      .collection(`location_poses/${this.location.id}/poses`)
      .onSnapshot((doc) => {
        doc.docs.forEach((rec) => {
          terminals.push(rec.data())
        })

        this.terminals = clone(terminals.sort((a, b) => a.name.localeCompare(b.name)))

        if (this.register.terminals && Object.keys(this.register.terminals).length > 0) {
          this.register.terminals = this.register.terminals.filter(term => this.terminals.findIndex(t => t.id === term.id) > -1)
        }

        this.$forceUpdate()
      })
    this.listeners.push(terminalsListener)

    const number = parseInt(clone(this.register.number))
    this.rules.reservedIds = (val) => {
      return (!this.reservedIds.includes(parseInt(val)) || (this.reservedIds.includes(parseInt(val)) && number === parseInt(val))) ||
        `Blagajna s oznakom ${val} već postoji!`
    }
    this.registerTypes = [
      { name: this.$t('$vuetify.cashRegister.registerTypes.mp'), value: 'MP', disabled: !this.company.certificate },
      { name: this.$t('$vuetify.cashRegister.registerTypes.vp'), value: 'VP' },
      { name: this.$t('$vuetify.cashRegister.registerTypes.all'), value: 'ALL', disabled: !this.company.certificate }
    ]

    this.registerLoginTypes = [
      { name: this.$t('$vuetify.cashRegister.registerLoginTypes.default'), value: 'DEFAULT' },
      { name: this.$t('$vuetify.cashRegister.registerLoginTypes.selectUser'), value: 'SELECT_USER' },
      { name: this.$t('$vuetify.cashRegister.registerLoginTypes.pincode'), value: 'PINCODE' }
    ]

    this.afterReceiptBehaviours = [
      { name: this.$t('$vuetify.cashRegister.afterReceiptBehaviours.emptyBasket'), value: 'EMPTY_BASKET' },
      { name: this.$t('$vuetify.cashRegister.afterReceiptBehaviours.showCashRegs'), value: 'SHOW_CASH_REGS' },
      { name: this.$t('$vuetify.cashRegister.afterReceiptBehaviours.showAllReceipts'), value: 'SHOW_ALL_RECEIPTS' }
    ]

    this.setOptionalParams()
    // v-money direktiva na money-input formatira vrijednost samo jednom, pri bindanju
    // na DOM (mounted) — ne prati kasnije promjene v-modela. Zato se cijela forma
    // renderira tek kad je register.deposit već postavljen na ispravnu vrijednost,
    // da polje "Polog na blagajni" pri prvom bindanju odmah dobije točan iznos.
    this.loaded = true
  },
  methods: {
    setOptionalParams () { // TODO: Make unique params checker for dirty (and different v-model) fields.
      this.registerName = clone(this.register.name)
      this.registerNumber = clone(this.register.number)
    },
    getOptionalParams () {
      const returnObject = {
        name: this.register.name,
        number: parseInt(this.register.number),
        type: this.register.type
      }

      if (this.register.printer) {
        returnObject.printer = this.register.printer.id
      }

      if (this.register.terminals && this.register.terminals.length > 0) {
        returnObject.terminals = this.register.terminals
      } else {
        returnObject.terminals = []
      }

      if (this.register.terminal_type) {
        returnObject.terminal_type = this.register.terminal_type
      }

      if (duck(this.register.name, this.registerName)) delete returnObject.name
      if (this.register.number === this.registerNumber) delete returnObject.number
      const deposit = this.$refs.deposit.currencyToFloat(this.register.deposit) * 100
      if (deposit && deposit > 0) returnObject.deposit = deposit
      returnObject.login_type = this.register.login_type
      returnObject.after_receipt_behaviour = this.register.after_receipt_behaviour
      return returnObject
    },
    submit () {
      const oldRegister = clone(this.register)
      const newRegister = clone(this.initialRegister)
      oldRegister.deposit = currencyToFloat(oldRegister.deposit) * 100
      const printerId = oldRegister.printer.id ?? oldRegister.printer
      oldRegister.printer = (printerId)
      newRegister.number = String(newRegister.number)

      if (duck(oldRegister, newRegister)) {
        this.showMsgBox({ text: this.$t('$vuetify.errors.noChangesInEntities'), actions: ['ok'], cancelBtnText: 'OK', color: 'error' })
        return
      }

      const that = this
      if (!this.$refs.editCashRegisterForm.validate()) return
      this.submitting = true

      try {
        const reqId = uuidv4()
        this.$forceUpdate()
        const payload = {
          action: {
            resource_id: this.register.id,
            operation: 'update',
            entity: 'cash_register',
            params: {
              company_id: this.company.id,
              location_id: this.location.id,
              ...this.getOptionalParams()
            }
          }
        }

        df.doc(`request/${reqId}`).set(
          {
            user_id: `${auth.currentUser.uid}`,
            device_id: 'web',
            created: `${new Date().getTime()}`,
            type: 'cashregister',
            payload: btoa(unescape(encodeURIComponent(JSON.stringify(payload))))
          }
        ).then((doc) => {
          that.$emit('saved', { id: this.register.id, name: this.register.name })
          that.initialRegister = clone(oldRegister)
          that.submitting = false
        }).catch(function (error) {
          // console.error('Error writing document: ', error)
          that.showMsgBox({ text: error || 'Internal error', actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
          that.submitting = false
        }).finally(() => {
        })
      } catch (error) {
        that.showMsgBox({ text: error || 'An error has occurred', actions: ['cancel'], cancelBtnText: 'OK', color: 'error' })
        that.submitting = false
      }
    }
  }
}
</script>
<style scoped>
.form-input >>> .v-input__slot {
  border-radius: 12px !important;
  background: #ffffff !important;
  min-height: 40px !important;
}
.form-input >>> fieldset {
  border-color: #e5e7eb !important;
  border-width: 1px !important;
  border-radius: 12px !important;
}
.form-input >>> .v-input__slot:hover fieldset {
  border-color: #00BCD4 !important;
}
.form-input.v-input--is-focused >>> fieldset {
  border-color: #00BCD4 !important;
  border-width: 2px !important;
}
.form-input >>> input {
  font-size: 13px !important;
}
.btn-primary {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 11px 22px;
  background-color: #00BCD4 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,188,212,0.3);
  transition: background-color 0.15s;
  text-transform: none !important;
}
.btn-primary:hover:not(:disabled) {
  background-color: #0097A7 !important;
}
.btn-primary:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
}

.business-settings-inline-form {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.business-settings-inline-form>>>form {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.business-settings-inline-form>>>.v-card {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.business-settings-inline-form>>>.v-card__text {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
}

.form-footer-sticky {
  flex: 0 0 auto;
  background: #fff;
  border-top: 1px solid #F3F4F6;
  padding: 16px 24px !important;
}
</style>
